export const colors = {
    GRAY_LIGHT: '#f7f7f7',
    GRAY_MEDIUM: '#e6e6e6',
    GRAY_DARK: '#3a3a3a',
    YELLOW: '#e6b800',
    RED: '#ed1c24',
    BLACK: '#000000',
    WHITE: '#FFFFFF',
    GREEN: '#0f7d3f',
    BLUE: '#1b2c58',
    DARK_BLUE: '#001753',
    CREAM: '#d2a784',
    LIGHT_CREAM: 'rgba(210, 167, 132, 0.5)',
}
